export default function SuggestionItem({ item, onAdd }) {
  return (
    <div
      style={{
        padding: "12px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 900, textTransform: "capitalize" }}>
          {item.name}
        </div>
        <div style={{ fontSize: 13, color: "#6b7280" }}>
          {item.category} • ₹{item.price}
        </div>
      </div>

      <button className="btn btnPrimary" style={{ flex: "unset" }} onClick={() => onAdd(item)}>
        + Add
      </button>
    </div>
  );
}
